import PropTypes from 'prop-types';
import { Box } from 'roo-ui/components';
import { CreditVoucherDisclaimer } from 'components/Disclaimers';
import { LineItem } from 'components/payments/primitives';
import { toDisplayDateOnlyFormat } from 'lib/utils';
import * as propTypes from 'components/payments/propTypes';

const CreditNoteLineItem = ({ total, paymentMethods }) => (
  <LineItem title="Credit voucher" totals={[total]}>
    {paymentMethods.map((creditNote, index) => (
      <Box key={index}>
        Credit voucher ending in {creditNote.lastFourCharacters}, expiring {toDisplayDateOnlyFormat(creditNote.expiry)}{' '}
        <CreditVoucherDisclaimer.Link />
      </Box>
    ))}
  </LineItem>
);

CreditNoteLineItem.propTypes = {
  total: propTypes.total.isRequired,
  paymentMethods: PropTypes.arrayOf(propTypes.creditNotePaymentMethod).isRequired,
};

export default CreditNoteLineItem;
